// redux/services/eventService/event.Services.js

import { baseApi } from "../baseApi";

export const EventApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createEvent: builder.mutation({
      query: (data) => ({
        url: "/event-create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Event"],
    }),

    // GET ALL
    getEvent: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/event-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Event", id })),
              { type: "Event", id: "LIST" },
            ]
          : [{ type: "Event", id: "LIST" }],
    }),

    // GET SINGLE
    getSingleEvent: builder.query({
      query: (id) => `/event-view/${id}`,
      providesTags: (result, error, id) => [{ type: "Event", id }],
    }),

    // UPDATE
    updateEvent: builder.mutation({
      query: (data) => ({
        url: "/event-update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Event", id },
        { type: "Event", id: "LIST" },
      ],
    }),

    // STATUS CHANGE - FIXED: Ensure id is passed correctly in the URL
    changeStatusEvent: builder.mutation({
      query: (id) => ({
        url: `/event-status/${id}`, // This will be /event-status/1
        method: "GET",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Event", id },
        { type: "Event", id: "LIST" },
      ],
    }),

    // DELETE
    deleteEvent: builder.mutation({
      query: (id) => ({
        url: `/event-delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Event", id },
        { type: "Event", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCreateEventMutation,
  useGetEventQuery,
  useGetSingleEventQuery,
  useUpdateEventMutation,
  useDeleteEventMutation,
  useChangeStatusEventMutation,
} = EventApi;